import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import useUserStore from "../components/UserStore";
import { hubLabsGet } from "../utils/hubLabsApiRequest";
import { hubGet } from "../utils/hubApiRequest";
import Translate from "../components/Translate";
import WorkoutViewPowerChart from "../components/WorkoutViewPowerChart";
import Loading from "../components/Loading";
import parse from 'html-react-parser';
import powerToZone from "../utils/powerToZone";

const WorkoutViewer = (props) => {
  document.title = "Wattbike Workout Viewer";

  // Get object ID from URL
  let { objectId } = useParams();

  // Global state setup
  const { user, signedIn, setUser, setSignedIn } = useUserStore(
    (state) => state
  );

  // Local state setup
  const [loading, setLoading] = useState(false);
  const [workout, setWorkout] = useState({});

  // load data once on page load
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        let workout = await getWorkout(
          100, // ftp for banding
          objectId // workout ID
        );
        await setWorkout(workout);
      } catch (error) {
        console.log("Error getting/processing workout", error);
        await setWorkout(false);
      }

      

      setLoading(false);
    };
    fetchData().catch("Fetching workout data error: ", console.error);
  }, []);

  ////////////////////////////////////////////////////////////////////////
  // Styles
  ////////////////////////////////////////////////////////////////////////
  const styles = {
    workoutImage: {
      width: 200,
      // float: "left"
    },
    outerContainer: {
      border: 0,
      position: "relative",
      zIndex: 1,
      textAlign: "center",
    },
    storeLinks: {
      margin: "0 auto",
    },
    title: {
      paddingTop: "40px",
    },
    header: {
      margin: "0 auto",
      fontFamily: "apercu",
      fontSize: "2em",
    },
    pageIntro: {
      margin: "0 auto",
      fontFamily: "apercu",
      fontSize: "1.3em",
      paddingBottom: "20px",
    },
    workoutIntro: {
      textAlign: "left",
    },
  }

  ////////////////////////////////////////////////////////////////////////
  // Layout
  ////////////////////////////////////////////////////////////////////////

  if (loading) {
    return (
      <>
        <h2>Loading...</h2>
      </>
    )
  } else if (!workout) {
    return (
      <>
      <div style={styles.outerContainer}>
        <p style={styles.pageIntro}>
        We can't load the workout preview at the moment, but don't worry this workout is available on the <span style={{ textDecoration: "underline" }}>FREE</span> Wattbike Hub app. Download from your app store below.
          </p>
          <br/>
           <div style={styles.storeLinks}>
          <a href="https://itunes.apple.com/us/app/wattbike-powerapp/id961711342?ls=1&mt=8" target="_blank"><img src="https://hub.wattbike.com/assets/img/app-store-badge.svg" alt="Download on the App Store" /></a> &nbsp;
          <a href="https://play.google.com/store/apps/details?id=com.wattbike.powerapp" target="_blank"><img alt="Get it on Google Play" src="https://hub.wattbike.com/assets/img/google-play-badge.svg" width="135" /></a>
        </div>
      </div>
      </>
    )
  } else {
    return (
      <>
      <div style={styles.outerContainer}>
        {/* <img
          src={workout.image ? workout.image : "https://wattbike-app-assets.s3.amazonaws.com/workout-images/HEADER_IMAGE_Workout_Detail_Eat_The_Elephant.jpg"} // default image used if needed
          alt="Image"
          style={styles.workoutImage}
        /> */}
        <h1 style={styles.title}>Ride the '{workout.title}' workout</h1>
        <div >
          <p style={styles.pageIntro}>
            Nearly there! You'll need the <span style={{ textDecoration: "underline" }}>FREE</span> Wattbike Hub app to ride this workout, download from your app store below.
          </p>
        </div>
        <div style={styles.storeLinks}>
          <a href="https://itunes.apple.com/us/app/wattbike-powerapp/id961711342?ls=1&mt=8" target="_blank"><img src="https://hub.wattbike.com/assets/img/app-store-badge.svg" alt="Download on the App Store" /></a> &nbsp;
          <a href="https://play.google.com/store/apps/details?id=com.wattbike.powerapp" target="_blank"><img alt="Get it on Google Play" src="https://hub.wattbike.com/assets/img/google-play-badge.svg" width="135" /></a>
        </div>
  
        <br /><br />
  
        <h3 style={styles.title}>{workout.title}</h3>
        <h5>{workout.intro}</h5>
        <WorkoutViewPowerChart workoutData={workout} />
        <p style={styles.workoutIntro}>{parse(workout.notes ? workout.notes : '')}</p>
        <br/>
        <div style={styles.storeLinks}>
          <a href="https://itunes.apple.com/us/app/wattbike-powerapp/id961711342?ls=1&mt=8" target="_blank"><img src="https://hub.wattbike.com/assets/img/app-store-badge.svg" alt="Download on the App Store" /></a> &nbsp;
          <a href="https://play.google.com/store/apps/details?id=com.wattbike.powerapp" target="_blank"><img alt="Get it on Google Play" src="https://hub.wattbike.com/assets/img/google-play-badge.svg" width="135" /></a>
        </div>
      </div>
  
      </>
    );
  }
  
};


////////////////////////////////////////////////////////////////////////
// Fetch Workout from Hub API
////////////////////////////////////////////////////////////////////////

// const getLeaderboardSessions = async (params = {}) => {
//   // compile all options
//   let requestOptions = {
//     resource: "leaderboard",
//     params: params,
//     cache: false,
//   };

//   // run the query
//   let response = await hubLabsGet(requestOptions);
//   return response;
// };

/////////////

const getWorkout = async (ftp, id) => {
  // // compile all options
  // let requestOptions = {
  //   resource: "Workout/" + id,
  //   authUser: null,
  //   where: null,
  //   include: null,
  //   order: null,
  //   limit: null,
  //   skip: null,
  // };

  // // run the query
  // let response = await hubGet(requestOptions);

  // compile all options
  let requestOptions = {
    resource: "workout",
    params: {workoutId: id},
    cache: false,
  };

  // run the query
  let response = await hubLabsGet(requestOptions);
  // console.log(response)

  // create higharts friendly data - only for segment based WOs for now
  let chartData = [];
  let zonedChartData = [[],[],[],[],[],[],[]];
  if (response.segments) {
    let cumulativeTime = 0;
    for (let i = 0; i < response.segments.length; i++) {
      let targetPower = response.segments[i].start * (ftp / 100);
      let zone = powerToZone(targetPower, ftp);
      let zoneNumber = zone ? zone.number : 1;

      chartData.push([cumulativeTime, 0]);
      chartData.push([cumulativeTime, targetPower]);
      chartData.push([cumulativeTime + response.segments[i].duration, targetPower]);
      chartData.push([cumulativeTime + response.segments[i].duration, 0]);

      zonedChartData[zoneNumber].push([cumulativeTime, 0]);
      zonedChartData[zoneNumber].push([cumulativeTime, targetPower]);
      zonedChartData[zoneNumber].push([cumulativeTime + response.segments[i].duration, targetPower]);
      zonedChartData[zoneNumber].push([cumulativeTime + response.segments[i].duration, 0]);

      cumulativeTime += response.segments[i].duration;
    }
  } else {
    chartData = null;
  }

  response.chartData = chartData;
  response.zonedChartData = zonedChartData;

  return response;
};

export default WorkoutViewer;
